import { createFileRoute } from "@tanstack/react-router";
import HeadManager from "../services/HeadManager";
import { useEffect } from "react";
import { trackCustomEvent } from "../services/analytics";

export const Route = createFileRoute("/checkout")({
  head: (ctx) => {
    return HeadManager.routerHead(ctx);
  },
  component: RouteComponent,
  staticData: {
    booking_engine: {
      show_checkout: true,
    },
  },
});

function RouteComponent() {
  useEffect(() => {
    trackCustomEvent("checkout_view", { value: 10.0, currency: "USD" });
  }, []);
  return <></>;
}
